import React from 'react';
import dayjs from 'dayjs';

import { Label } from '@atlas/ui';

const dateTimeFormat = 'DD.MM.YYYY';

const LuckyDayDates = ({ endTime, startTime }) => {
  const formattedStartTime = dayjs(startTime).format(dateTimeFormat);
  const formattedEndTime = dayjs(endTime).format(dateTimeFormat);

  return (
    <div className="luckyday-dates description short-content">
      <div className="luckyday-date">
        <div className="luckyday-date__text">
          <Label message="start" />:
        </div>
        <div className="luckyday-date__amount">{formattedStartTime}</div>
      </div>

      <div className="luckyday-date">
        <div className="luckyday-date__text">
          <Label message="the_end" />:
        </div>
        <div className="luckyday-date__amount">{formattedEndTime}</div>
      </div>
    </div>
  );
};

export default LuckyDayDates;
